import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * Every user will have cart (Quantity of all Products in Cart is set to 1 by default), wishList by default
 * */

export const users = [
  {
    _id: uuid(),
    firstname: "Adarsh",
    lastname: "Balika",
    email: "adarshbalika@gmail.com",
    password: "adarshbalika",
    address: [
      {
        _id: uuid(),
        name: "Adarsh Balika",
        area: "Aradhana Nagar",
        city: "Kollam",
        state: "	Kerala",
        pincode: "691008",
        phoneNumber: "1234567890",
      },
      {
        _id: uuid(),
        name: "	Ramesh Chaudhary",
        area: "15,A.H Mitra Road,Nediarpara",
        city: "Kolkata",
        state: "West Bengal",
        pincode: "741101",
        phoneNumber: "03472 252 139",
      },
    ],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
];
